<template>
  <div class="col-md-12">
    <div  class="my-3 ml-2 " v-if="stDocumento">
      <b-button @click = "verDocumento" variant="success">Ver documento cargado</b-button>
      <b-button v-if="!subirNuevo"  @click = "cargarNuevo(true)" class="ml-2"variant="warning">Sustituir documento</b-button>
      <b-button v-else  @click = "cargarNuevo(false)" class="ml-2"variant="danger">No subir</b-button>
      <b-modal id="modal-documento" size="xl">
        <iframe
          v-if="urlCompleto"
          :src="urlCompleto"
          width="100%"
          height="500px"
          frameborder="0">
        </iframe>
      </b-modal>
      
    </div>
    <b-card-code v-if="!stDocumento || subirNuevo" class="mt-2 principal">
      <div class="title mt-0 mb-1">
        CARGAR AQUÍ DOCUMENTO AS 400
      </div>

      <div class="mainz mt-0 mb-0">
        <div class="dropzone-container" @dragover="dragover" @dragleave="dragleave" @drop="drop">
          <input 
            id="fileInput" 
            ref="file" 
            type="file" 
            multiple 
            name="file" 
            class="hidden-input"
            accept=".pdf,.jpg,.jpeg,.png" 
            @change="onChange"
          />

          <label for="fileInput" class="file-label">
            <div v-if="isDragging">
              <span span="dragging-active">Soltar el documento aqui</span>
            </div>
            <div v-else>
              <u>Arrastre los archivos</u>
            </div>
          </label>
          <div v-if="files.length" class="preview-container mt-2">
            <div v-for="file in files" :key="file.name" class="preview-card">
              <div>
                <p>
                  {{ file.name }}
                  {{ Math.round(file.size / 1000) + "KB" }}
                </p>
              </div>
              <div>
                <button 
                  class="ml-2" 
                  type="button" 
                  title="Remove file" 
                  @click="remove(files.indexOf(file))"
                >
                  <b>×</b>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="demo-vertical-spacing mt-2">
        <b-progress 
          id="my-progress" 
          :value="this.value" 
          :max="this.max_value" 
          striped 
          variant="info"
          class="progress-bar-info" 
        />

      </div>
      <div class="text-center mt-2 mb-2">
        <b-button 
          v-ripple.400="'rgba(255, 255, 255, 0.15)'" 
          size="sm" type="submit"    
          variant="primary"
          :disabled="bloqueo_boton" 
          class="btn-guardar" 
          @click="cargarDocumentoAs400">
          <feather-icon icon="SaveIcon" size="16" class="align-text-top" />
          <span>&nbsp;Cargar Archivo</span>
        </b-button>
      </div>
      <div>
        {{ fileuploaded }}
      </div>
    </b-card-code>
  </div>
</template>
<script>
import { mapState } from "vuex";
import BCardCode from '@core/components/b-card-code'
import { BButton, BProgress, BFormCheckbox, BRow, BFormGroup, BCol } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive';
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import vSelect from "vue-select";

export default {
  directives: {
    Ripple,
  },
  components: {
    vSelect, BCol, BFormGroup, BRow,
    BFormCheckbox,
    BButton,
    BProgress,
    BCardCode,
  },

  data() {
    return {
      subirNuevo : false,
      urlCompleto: null,
      size_file: 0,
      importacion: false,
      bloqueo_boton: false,
      isDragging: false,
      files: [],
      fileuploaded: '',
      filecsv: 'saludos',
      value: 0,
      max_value: 100,
      selectedOptionF: { label: 'Data Sur' },
      selectedOptionT: { label: 'Importaciones' },
      optionF: [
        { label: 'Data Sur' },
        { label: 'Senae' },
        { label: 'Otros' },
      ],
      optionT: [
        { label: 'Importaciones' },
        { label: 'Exportaciones' },
        { label: 'Otros' },
      ],
    }
  },
  computed : {
    ...mapState({
      stDocumento: state => state.atencionCita.docAs400.docAs400,
    }),
  },
  watch: {

  stDocumento: {
  deep: true,
  handler(newValue) {
    if (newValue) { // Asegúrate de que newValue no sea null
      const fileName = decodeURIComponent(newValue);
      const fullDownloadUrl = `${rutas.axios}file/show${fileName}`
      this.urlCompleto = fullDownloadUrl
      //this.motivoConsulta = newValue;
    } else {
      //this.motivoConsulta = ''; // o el valor por defecto que desees
    }
  }
},


},

 

  methods: {
    cargarNuevo(item){
      this.subirNuevo = item
    },
    verDocumento(){
      this.$bvModal.show("modal-documento")
    },
    onChange() {
      this.files = [...this.$refs.file.files]
    },

    dragover(e) {
      e.preventDefault()
      this.isDragging = true
    },

    dragleave() {
      this.isDragging = false
    },

    drop(e) {
      e.preventDefault()
      this.$refs.file.files = e.dataTransfer.files
      this.onChange()
      this.isDragging = false
    },

    remove(i) {
      this.files.splice(i, 1)
    },

      async cargarDocumentoAs400() {
          const file = this.files[0];
          this.urlDoc = await this.uploadFileServer(file); 
          localStorage.setItem('doccitamedica', this.urlDoc);
      },

      async uploadFileServer(file) {
          const formData = new FormData();
          formData.append('file', file);
          try {
              const response = await axios.post(rutas.axios +'api/upload/', formData, {
                  headers: {
                      'Content-Type': 'multipart/form-data'
                  }
              });
              if (response.data.url) {
                  this.$swal({
                      title: 'Imagen Cargada',
                      text: 'Se ha cargado la imagen al servidor',
                      icon: 'success',
                      confirmButtonText: 'Entendido'
                  });
                  console.log(response.data.url);
                  
                  localStorage.removeItem("doc");

                  let doc = true
                  localStorage.setItem("doc", doc);
                  return response.data.url; // Assuming the backend sends the URL in the "url" key of the response
              } else {
                  this.$swal({ 
                      title: 'Error al cargar',
                      text: 'No se ha cargado la imagen',
                      icon: 'error',
                      confirmButtonText: 'Entendido'
                  })
                  return '';
              }
          } catch (error) {
              console.log('File upload failed:', error);
          };
      },
  }
}
</script>
<style>
.principal .card-header {
    display: none !important
}

.principal .card-body {
    padding-bottom: 0 !important;
}
</style>
<style scoped src="@/assets/css/dropfile.css"></style>
